import { makeAutoObservable } from 'mobx';
import { apiServiceV2 } from '../../../../services/apiService';
import { globalStore } from '../../../../global.store';
import { unityProviderStore } from '../../../UnityLoader/unity.provider.store';

class SaveAsTemplateStore {
  templateName = '';

  showSaveAsTemplatePopup = false;

  constructor() {
    makeAutoObservable(this);
  }

  setTemplateName = (name: string): void => {
    this.templateName = name;
  };

  setShowSaveAsTemplatePopup = (state: boolean): void => {
    this.showSaveAsTemplatePopup = state;
  };

  saveTemplate = async () => {
    // const res = await apiServiceRoom.saveTemplate({
    //     public_id: cacheService.get("RoomId"),
    //     template_name: value
    // });
    const res = await apiServiceV2.saveTemplate(unityProviderStore.roomData.id);
    if (!res.error) {
      globalStore.setToasts(true, 'its_success');
    } else {
      globalStore.setToasts(true, 'something_went_wrong');
    }
    this.setShowSaveAsTemplatePopup(false);
  };
}

export const saveAsTemplateStore = new SaveAsTemplateStore();
